<template>
  <el-dialog
      :visible.sync="visible"
      :title="title"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="1000px"
  >
    <el-table v-loading="dataListLoading" :data="dataList" border style="width: 100%;">
      <el-table-column type="index" label="行号" header-align="center" align="center" width="50"></el-table-column>
      <el-table-column prop="operateDate" label="日期" header-align="center" align="center">
        <template #default="{row}">
          {{row.operateDate||'期初余额'}}
        </template>
      </el-table-column>
      <el-table-column prop="payAmount" label="借方" header-align="center" align="center"></el-table-column>
      <el-table-column prop="receiveAmount" label="贷方" header-align="center" align="center">
        <template #default="{row}">
          {{row.receiveAmount>row.limitAmount?(0-row.receiveAmount):row.receiveAmount}}
        </template>
      </el-table-column>
      <el-table-column prop="limitAmount" label="余额" header-align="center" align="center"></el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'

export default {
  name: 'amount-flow-dialog',
  mixins: [mixinViewModule],
  data () {
    return {
      title: '',
      visible: false,
      mixinViewModuleOptions: {
        getDataListURL: '/trade/company/amount-flow',
        getDataListIsPage: false,
        activatedIsNeed: false
      },
      sellerName: '',
      dataForm: {
        sellerId: '',
        code: ''
      }
    }
  },
  methods: {
    init (sellerId, sellerName) {
      if (!sellerId || !sellerName) {
        return this.$message.error('参数错误')
      }
      this.dataForm.sellerId = sellerId
      this.sellerName = sellerName
      this.title = `${this.sellerName}往来明细账`
      this.reload()
      this.visible = true
    }
  }
}
</script>

<style scoped>

</style>
